import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addPagesFailure,
  //
  addPagesSuccess,
  deletePagesFailure,
  //
  deletePagesSuccess,
  editPagesFailure,
  //
  editPagesSuccess,
  fetchPages as fetchPagesAction,
  fetchPagesFailure,
  fetchPagesSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  uploadFileFailure,
  //
  uploadFileSuccess,
} from "./actions";
import {
  ADD_PAGES,
  DELETE_PAGES,
  EDIT_PAGES,
  FETCH_PAGES,
  GET_VIEW_DATA,
  UPLOAD_FILE,
} from "./constants";

export function* fetchPagesSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const data = yield call(api(token).get, `/api/pages?${query}`);
    yield put(fetchPagesSuccess(data));
  } catch (e) {
    yield put(fetchPagesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching pages!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/pages/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addPagesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/pages/add`, payload.data);
    if (data) {
      yield put(successAlert("Page added successfully!"));
      yield put(addPagesSuccess());
      yield put(
        fetchPagesAction({
          page: 1,
          limit: 10,
          company_id: payload.data.company_id,
        })
      );
    }
  } catch (e) {
    yield put(addPagesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editPagesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/pages/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Page updated successfully!"));
      yield put(editPagesSuccess());
      yield put(getViewDataAction(payload?.id ?? ""));
    }
  } catch (e) {
    yield put(editPagesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deletePagesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/pages/${payload?.id}`);
    if (data) {
      yield put(successAlert("Page deleted successfully!"));
      yield put(deletePagesSuccess());
      yield put(
        fetchPagesAction({
          page: 1,
          limit: 10,
          company_id: payload?.company_id,
        })
      );
    }
  } catch (e) {
    yield put(deletePagesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* uploadFileSaga({ payload, onUploadSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/pages-file-upload`,
      payload.data
    );
    if (data) {
      yield put(uploadFileSuccess());
      typeof onUploadSuccess === "function" &&
        onUploadSuccess(data, payload.fileSettings);
    }
  } catch (e) {
    yield put(uploadFileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while uploading file!"));
  }
}

export function* fetchPagesFlow() {
  yield takeEvery(FETCH_PAGES, fetchPagesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addPagesFlow() {
  yield takeEvery(ADD_PAGES, addPagesSaga);
}
export function* editPagesFlow() {
  yield takeEvery(EDIT_PAGES, editPagesSaga);
}
export function* deletePagesFlow() {
  yield takeEvery(DELETE_PAGES, deletePagesSaga);
}
export function* uploadFileFlow() {
  yield takeEvery(UPLOAD_FILE, uploadFileSaga);
}

export default function* PagesSaga() {
  yield all([
    fetchPagesFlow(),
    addPagesFlow(),
    editPagesFlow(),
    deletePagesFlow(),
    getViewDataFlow(),
    uploadFileFlow(),
  ]);
}
